if (!customElements.get('beauty-predictive-search')) {
  class BeautyPredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('[data-beauty-search-input]');
      this.results = this.querySelector('[data-beauty-search-results]');
      this.cache = new Map();
      this.abortController = null;
      this.timer = null;

      if (!this.input || !this.results) return;

      this.input.addEventListener('input', () => {
        window.clearTimeout(this.timer);
        this.timer = window.setTimeout(() => this.search(), 180);
      });

      this.input.addEventListener('focus', () => {
        const key = this.input.value.trim().toLowerCase();
        if (key.length >= 2 && this.cache.has(key)) this.render(this.cache.get(key));
      });

      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.close();
          return;
        }
        if (event.key === 'ArrowDown' && !this.results.hidden) {
          const firstLink = this.results.querySelector('a[href]');
          if (firstLink) {
            event.preventDefault();
            firstLink.focus();
          }
        }
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.close();
          this.input.focus();
        }
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close();
      });
    }

    async search() {
      const term = this.input.value.trim();
      const key = term.toLowerCase();

      if (term.length < 2) {
        this.close();
        return;
      }

      if (this.cache.has(key)) {
        this.render(this.cache.get(key));
        return;
      }

      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();

      const params = new URLSearchParams({
        q: term,
        section_id: 'helper-predictive-search',
        'resources[type]': 'product',
        'resources[limit]': '10',
        'resources[options][unavailable_products]': 'last'
      });

      try {
        const response = await fetch(`${KROWN.settings.routes.predictive_search_url}?${params.toString()}`, {
          signal: this.abortController.signal
        });
        if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);

        const text = await response.text();
        const documentResult = new DOMParser().parseFromString(text, 'text/html');
        const section = documentResult.querySelector('#shopify-section-helper-predictive-search');
        const markup = section ? section.innerHTML : '';
        this.cache.set(key, markup);

        if (this.input.value.trim().toLowerCase() === key) this.render(markup);
      } catch (error) {
        if (error.name !== 'AbortError') this.close();
      }
    }

    render(markup) {
      this.results.innerHTML = markup;
      if (!this.results.querySelector('.cart-item')) {
        this.close();
        return;
      }

      this.results.querySelectorAll('a[href]').forEach((link) => link.setAttribute('tabindex', '0'));
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('beauty-predictive-search', BeautyPredictiveSearch);
}
